<div class="dialog-header" cdkDrag 
cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle >
  <h2 mat-dialog-title>Select an Effort</h2>
  <mat-icon>drag_indicator</mat-icon>
</div>

<mat-dialog-content class="dialog-content" [formGroup]="form">
  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Filter by Title or Key</mat-label>
    <input matInput formControlName="searchTerm" placeholder="Search" />
    </mat-form-field>

    <mat-selection-list>
      <mat-list-option *ngFor="let effort of filteredEfforts" [value]="effort" (click)="onSelectEffort(effort)"
        [selected]="form.get('selectedEffort')!.value === effort">
        {{ effort.title }} ({{ effort.key }})
      </mat-list-option>
    </mat-selection-list>
    @if (loaded && !efforts.length) {
      <p>No eligible efforts are available. Department admins need membership in the effort's owning department or effort ownership. HR efforts cannot be edited here.</p>
    } @else if (loaded && !filteredEfforts.length) {
      <p>No efforts match your search.</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [disabled]="!form.get('selectedEffort')!.value" (click)="onSelectClick()">
      Select
    </button>
    <button mat-button (click)="onCancelClick()">Cancel</button>
  </mat-dialog-actions>
